import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import axios from 'axios';
import { useAppContext } from '../AppContext';
import MenuItem from '@mui/material/MenuItem';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolderOutlined';
import { axios_tenant } from '../../../../axios';
import { toast } from 'react-toastify';

function CreateFolder({ fetchFolderContents, handleClose }) {
  const appData = useAppContext();
  const [folderName, setFolderName] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [modalError, setModalError] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);


  const handleFolderNameChange = (e) => {
    setFolderName(e.target.value);
  };

  const handleCreateFolder = () => {
    setModalOpen(true);
  };

  const handleCreateFolderConfirm = () => {
    if (folderName.trim() === '') {
      setValidationError(true);
    } else {
      axios_tenant
        .post(`/collaboration/createFolder`, {
          folderName: folderName,
          parentFolderId: appData.folderId
        })
        .then((response) => {
          fetchFolderContents();
          handleClose();
          toast.success("Folder created succesfully");
        })
        .catch((error) => {
          setModalError('Failed to create folder. Please try again.');
        });
    }
  };

  return (
    <><MenuItem onClick={handleCreateFolder}>
      <CreateNewFolderIcon style={{ marginRight: 8, color: '#676773' }} />
      Create Folder
    </MenuItem>
      <Modal
        open={isModalOpen}
        onClose={handleClose}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: 400,
            height: 250,
            borderRadius: 4,
            bgcolor: 'white',
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <div style={{ textAlign: 'left', fontWeight: 'bold' }}>Create a Folder</div>
          {modalError && (
            <div style={{ color: 'red', textAlign: 'left' }}>{modalError}</div>
          )}
          <TextField
            autoFocus
            label="Folder Name"
            variant="outlined"
            fullWidth
            onKeyDown={(e) => { e.stopPropagation(); }}
            value={folderName}
            onChange={handleFolderNameChange}
            error={validationError}
            helperText={validationError ? 'Folder name is required' : ''}
          />
          <div style={{ alignSelf: 'flex-end' }}>
            <Button
               style={{ backgroundColor: 'orange', color: 'white', textTransform: 'none' }}
              variant="contained"
              color="primary"
              onClick={handleCreateFolderConfirm}
            >
              Create
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default CreateFolder;
